(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["bundle-selector"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('.bundle-card--selected').forEach(function(card) {
    card.addEventListener('click', function(e) {
      e.preventDefault();
    });
  });
  } catch(e) { console.error(e); }
})();

})();
